module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: 'CCA官网账号不能为空'
      }],
      "label": "CCA官网账号",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入CCA官网账号"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: 'CCA官网密码不能为空'
      }],
      "label": "CCA官网密码",
      "type": "password",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入CCA官网密码"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.ncounty ? _vm.formData.nprovince + '/' + _vm.formData.ncity + '/' + _vm.formData.ncounty : '',
      "input-align": "right",
      "label": "省市",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showNamekey = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNamekey),
      callback: function($$v) {
        _vm.showNamekey = $$v
      },
      expression: "showNamekey"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.namekeyList,
      "value": _vm.formData.namekey
    },
    on: {
      "confirm": _vm.onNamekeyConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12107efc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubBind.vue
// module id = 2216
// module chunks = 0